var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box-403"},[_c('div',[_c('h1',[_vm._v("500")]),_c('h3',[_vm._v(" "+_vm._s(_vm.$t('errorLog.errorTypes.500'))+" "),_c('a',{attrs:{"href":"javascript:history.back()"}},[_vm._v(_vm._s(_vm.$t('back')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }